import {inject} from 'aurelia-framework';  
import {Router} from 'aurelia-router';
import {AuthService} from '../../services/authService';
import {UserMessageService} from '../../services/userMessageService';
import {AccountAPI} from '../../services/accountAPI';

@inject(AuthService, Router, AccountAPI, UserMessageService)
export class Cancel {
    constructor(authService, router, api, userMessageService) {
        
        this.authService = authService;
        this.router = router;
        this.api = api;
        this.userMessageService = userMessageService;

        this.step = 0;

        this.reason = null;
        this.reasonOther = "";

        this.appName = window.app_name ? window.app_name : "Magnfi" 
        this.step = (window.whitelabel) ? 1 : 0;
        
        this.reasonList = [
            { id: 1, text: "I'm not using the service" }, 
            { id: 2, text: "People aren't responding to my request" }, 
            { id: 3, text: "It's too expensive" },
            { id: 4, text: "I'm having technical issues" },
            { id: 5, text: "I'm using another service" },
            { id: 0, text: "Other" }
        ];

    }

    activate() {
        this.requestCount = this.authService.getAccount().request_count;
        console.log("current account data",this.appName);
    }

    abort() {
        this.router.navigate('account');
    }

    cancelAccount() {
        
        this.api.cancelAccount(
            {reason: this.getSelectedReason()},
            this.authService.getUser().token,
            this.cancelSuccess.bind(this),
            this.apiError.bind(this)

        );
        
    }

    cancelSuccess() {
        this.step = 3;
        this.authService.accountClosed();
        setTimeout(() => {this.authService.logout();}, 6000); 
    }

    apiError(msg) {
        this.userMessageService.setUserError("user", msg);
        this.loading = false;
    }

    getSelectedReason() {
        if(this.reason == 0)
            return this.reasonOther;
        else {
            for(var i = 0; i < this.reasonList.length; i++) {
                if(this.reasonList[i].id == this.reason)
                    return this.reasonList[i].text;
            }
        }
    }
}